import NotifyMessage   from "./NotifyMessage";
import NotifyTypeClass from "./NotifyTypeClass";

class Notify {
  constructor(
    private readonly _type: NotifyTypeClass = new NotifyTypeClass(),
    private readonly _message: NotifyMessage = new NotifyMessage()
  ) {
  }

  get type() {
    return this._type;
  }

  get message() {
    return this._message;
  }
}

export default Notify;
